const exported = {
  DOMParser: window.DOMParser,
  XMLSerializer: window.XMLSerializer,
};

export default exported;

export const { DOMParser, XMLSerializer } = exported;
